import { useTranslation as useBaseTranslation } from "react-i18next";
import { LngNs } from "../utils/i18n";

export const useCustomTranslation = () => {
  const { t, i18n } = useBaseTranslation([LngNs.zypher]);
  return { t, i18n };
};
